import type { BankAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { convertCurrency } from "../genericCalculations/convertCurrency";
import { calculateOwnership } from "../genericCalculations/ownership";

export const bankBalance = (userProduct: BankAsset) => {
  const balance = userProduct?.amount || 0;
  const ownership = userProduct?.ownership || 0;

  return calculateOwnership(balance, ownership);
};

export const convertBankBalance = (
  userProduct: BankAsset,
  currencies: { baseCurrency: Fiat; currentCurrency: Fiat }
) => {
  const { baseCurrency, currentCurrency } = currencies;
  const balance = bankBalance(userProduct);

  return convertCurrency(balance, baseCurrency, currentCurrency);
};
